exports.APIS = {
  Auth: {
    CreateCustomerSignup: "/customer-signup",
    SEND_OTP: "/sendOtp",
    VERIFY_OTP: "/otp-verification",
    CreateVendor1Signup: "/vendor-signup",
    CreateVendor2Signup: "/vendor-shop",
    CreateVendor3Signup: "/vendor-receive-docs",
    CreateExpert1Signup: "/expert-signup",
    CreateExpert2Signup: "/expert-details",
    // login: "/login",
    sendLoginOtp: "/sendLoginOtp",
    LoginverifyOtp: "/login",
    GETCustomer: "/get-customer",
    GETVendor: "/get-vendor",
    GETExpert: "/get-expert",
    Update_Customer: "/update-customer-profile",
    Update_Vendor: "/update-vendor-profile",
    Update_Expert: "/update-expert-profile",
    Update_Vendor_Shop: "/update-vendor-shop",
    addharSendOtp: "/aadhaar/send-otp",
    addharVerifyOtp: "/aadhaar/verify-otp",
  }, // mine
  UserGet: "/common/auth/user-info",
  ChangePassword: "/common/auth/change-password",

  Masters: {
    Country: "/admin/masters/country",
  },

  ContactUs: {
    Contact_Us: "/contactUs",
  },

  Commons: {
    AllState: "/state",
    AllDistrict: "/district",
    AllCartegory: "/servicecategory",
    AllProfession: "/get-profession",
    AllPrivacyPolicy: "/privacypolicy",
    AllTermcondition: "/termcondition",
    AllAppSetup: "/app-set-up",
    AllCategories: "/servicecategory",
    AllProfessions: "/get-profession",
    AllPurchaseDate: "/get-purchase-date",
    AllTaluka: "/taluqa",
    AllBanners: "/banner",
    AllAboutUs: "/web-about-us",
    AllKilometer: "/kilometers",
    AllNotification: "/getnoti",
    AllSubServiceCategories: "/sub-service-categories",
    AllSubProfession: "/sub-profession",
  },

  UserManagement: {
    Roles: "/admin/employee-management/role",
    Builder: "/admin/employee-management/builder",
    Users: "/admin/employee-management/user",
    Sales: "/admin/employee-management/sales",
  },
  Subscription: {
    Subscription_Plan: "/subscription-plan",
    Buy_Subscription: "/subscription",
    UserWalletHistory: "/get-subscriptionHistory",
  },
  Vendor_Expert: {
    Vendors_Experts: "/web-get-vendors-experts",
    VendorEnquiry: "/vendor-enquiry",
    ExpertEnquiry: "/expert-enquiry",
    getVendorExpertList: "/vendor-expert-history",
    RateUs: "/rate-us",
    getVendorCustomerList: "/vendor-customer-lead",
    getExpertCustomerList: "/expert-customer-lead",
    Vendor_Call: "/vendor-enquiry-call",
    getVendorCustomerHistory: "/vendor-purchase-lead",
    Expert_Call: "/expert-enquiry-call",
    getExpertCustomerHistory: "/expert-purchase-lead",
    availableToday: "/available-today",
    getAllNotification: "/getnoti",
  },
};
